import { Node, SimpleNode } from '../../models/models';
import { clearNodeSelected, getMyNodesFailed, getMyNodesSuccess, getNodeFailed, getNodeSuccess } from './node.action';

export type NodeState = {
    readonly myNodes: SimpleNode[];
    readonly nodeSelected: Node | null;
};

const INITIAL_STATE: NodeState = {
    myNodes: [],
    nodeSelected: null,
};


export const nodeReducer = (state = INITIAL_STATE, action: any) => {

    if (getMyNodesSuccess.match(action)) {
        return { ...state, ...action.payload, nodeSelected: null };
    }

    if (getNodeSuccess.match(action)) {
        return { ...state, ...action.payload };
    }

    if (getMyNodesFailed.match(action)) {
        return { ...state, myNodes: [], nodeSelected: null };
    }

    if (getNodeFailed.match(action)) {
        return { ...state, nodeSelected: null };
    }

    if (clearNodeSelected.match(action)) {
        return { ...state, nodeSelected: null };
    }

    return state;
};